module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datadownload-content tc"
  }, [_c('banner', {
    attrs: {
      "clazz": "datadownload-banner",
      "url": "DataDownload"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "datadownload-section1 dib tl"
  }, [_c('div', {
    staticClass: "section1-leftlist dib"
  }, [_c('div', {
    staticClass: "selectlist-header tc"
  }, [_vm._v("资料下载")]), _vm._v(" "), _vm._l((_vm.downloadList), function(item) {
    return _c('div', {
      staticClass: "selectlist-cell tl",
      class: (item.id === _vm.listValue) ? 'is-active' : '',
      attrs: {
        "value": item.id
      },
      on: {
        "click": function($event) {
          return _vm.clickCell(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "section1-rightcontent dib"
  }, [_vm._l((_vm.cellList), function(item) {
    return _c('div', {
      staticClass: "content-cell"
    }, [_c('div', {
      staticClass: "icon-container dib"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.img),
        expression: "$global.globalPath + item.img"
      }],
      staticClass: "cell-icon",
      attrs: {
        "alt": "图片地址错误"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "cell-content dib"
    }, [_c('div', {
      staticClass: "content-title"
    }, [_c('div', {
      staticClass: "title-icon dib"
    }), _vm._v(" "), _c('h1', {
      staticClass: "title-misc dib"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content-misc"
    }, [_vm._v("\n            " + _vm._s(item.describe) + "\n          ")]), _vm._v(" "), _c('a', {
      staticClass: "content-footer db tr",
      attrs: {
        "href": _vm.getDetailLink(item.id)
      }
    }, [_c('div', {
      staticClass: "footer-link dib"
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('img', {
      staticClass: "footer-icon",
      attrs: {
        "src": require("../../assets/img/dataDownload/footer-icon.png"),
        "alt": "查看详情"
      }
    })])])])
  }), _vm._v(" "), (_vm.cellList.length === 0) ? _c('div', {
    staticClass: "nodata-misc tc"
  }, [_vm._v("暂无数据")]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe54dd9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataDownload/dataDownload.vue
// module id = 664
// module chunks = 12